app.controller('downloadInvoicesController', function ($rootScope, $scope, $filter, safeApply, invoiceService) {

  const currentYear = new Date().getFullYear()

  $scope.invoices = {
    year: currentYear,
    yearList: [currentYear, currentYear - 1],
    user_ids_raw: "",
    user_ids: [],
    invalid_entries: [],
    processing: false,
    last_file: null,
  }

  // Pulls in user info from the rootScope -> CRMController
  $rootScope.$watch('user_info', function () {
    $scope.user_info = $rootScope.user_info
  }, true)

  // One User ID per line - keeps unique numeric ID's
  $scope.parseUserIDs = function () {
    const entries = ($scope.invoices.user_ids_raw || '')
      .split(/\r?\n/)
      .map(entry => entry.trim())
      .filter(entry => entry.length > 0)

    let user_ids = [], invalid_entries = []
    entries.forEach(entry => {
      if (/^\d+$/.test(entry)) {
        const user_id = parseInt(entry, 10)
        if (user_ids.indexOf(user_id) === -1) user_ids.push(user_id)
      } else {
        if (invalid_entries.indexOf(entry) === -1) invalid_entries.push(entry)
      }
    })

    $scope.invoices.user_ids = user_ids
    $scope.invoices.invalid_entries = invalid_entries
  }

  $scope.createZipFile = async function () {
    $scope.parseUserIDs()

    if ($scope.invoices.user_ids.length == 0) {
      toastr.warning('Please enter at least one User ID.', 'Download Invoices')
      return
    }

    $scope.invoices.processing = true
    $scope.invoices.last_file = null
    safeApply($scope)

    try {
      const request = { user_ids: $scope.invoices.user_ids, year: parseInt($scope.invoices.year, 10) }
      console.log('createInvoices-> request :>> ', request)

      let results = await invoiceService.createInvoices(request)

      if (!results.success) throw results.error

      // The dashboard reports how many invoices actually made it into the zip - fall back
      // to the number of User ID's submitted when it doesn't send a count back.
      const invoice_count = results.invoice_count != null ? results.invoice_count : $scope.invoices.user_ids.length
      const timestamp = $filter('date')(new Date(), 'MM-dd-yy_HH-mm-ss')
      const filename = `Invoices_${timestamp}_${invoice_count}.zip`

      downloadBlob(results.blob, filename)

      $scope.invoices.last_file = filename
      toastr.success(`${invoice_count} invoice${invoice_count == 1 ? '' : 's'} downloaded.`, 'Download Invoices')
    } catch (error) {
      console.log('createZipFile-> error :>> ', error)
      toastr.error(error && error.message ? error.message : 'Unable to create the .zip file.', 'Download Invoices', { timeOut: 8000 })
    }

    $scope.invoices.processing = false
    safeApply($scope)
  }

  function downloadBlob(blob, filename) {
    const blobUrl = URL.createObjectURL(blob)
    let link = document.createElement("a")
    link.download = filename
    link.href = blobUrl
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000)
  }

})
